export const CUSTOM_FIELD_COLUMN_ID_PREFIX = `custom_field-`;
export const REPORT_COMPLETED_CUSTOM_FIELD_COLUMN_ID_PREFIX = `${CUSTOM_FIELD_COLUMN_ID_PREFIX}-report_completed-`;
export const REPORT_CANCELED_CUSTOM_FIELD_COLUMN_ID_PREFIX = `${CUSTOM_FIELD_COLUMN_ID_PREFIX}-report_canceled-`;
